import React, { useEffect, useMemo, useState } from "react";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";
import { formContentContainer, loaderOverlay } from "../../Style/loaderOverly";
import { AvForm } from "availity-reactstrap-validation";
import { Link, useNavigate, useParams } from "react-router-dom";
import { createPageData, orderFormData } from "./OrderFile";
import { LoaderCreatePage } from "../Loader/Loader";
import {
  DownloadPDFData,
  formatDate,
  formatNumber,
  getRecords,
  imageURL,
} from "../../services/api.service";
import "../../Style/hypperViewStyle.css";
import "../../Style/style.css";
import UserDetailsModal from "../../components/CommonForBoth/TopbarDropdown/UserProfile/UserDetailModel";
import PerchaseOrder from "./OrderPDF/PerchaseOrder";
import "jspdf-autotable";
import { toast } from "react-toastify";

const OrderView = () => {
  const breadcrumbItems = [];
  const { id } = useParams();
  const navigate = useNavigate();

  const { payload, navigatePage, headerName, getEndpoint, stageOptions } =
    createPageData();
  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(orderFormData());
  const [fetchedData, setFetchedData] = useState(null);
  const [searchQuery, setSearchQuery] = useState(""); // State for search query
  const [isCustomerModelOpen, setIsCustomerModelOpen] = useState(false);
  const [stageOption, setStageOption] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);

  useEffect(() => {
    if (fetchedData) {
      console.log("ereee");

      let data = fetchedData;

      const orderDocuments =
        data?.order_documents &&
        data?.order_documents?.map((item) => ({
          id: item?.id,
          document: item?.document,
          file: item?.file,
          is_active: item?.is_active,
        }));

      setFormData((prevState) => ({
        ...prevState,
        inputData: {
          ...prevState.inputData,
          ...data,
          order_documents: orderDocuments,
        },
      }));
    }
  }, [fetchedData]);

  const getEditData = async (id) => {
    try {
      let payload = {
        modelName: "orders",
        modifyResponse: true,
        getBuyItemObject: true,
        whereCondition: {
          id: id,
        },
        relations: [
          {
            module: "order_payment_details",
            moduleAs: "orderPaymentDetails",
          },
          {
            module: "order_items",
            moduleAs: "orderItemDetails",
            subModule: "item_masters",
            subModuleAs: "item",
            subSubModule: "uom_masters",
            subSubModuleAs: "uom",
          },
          {
            module: "projects",
            moduleAs: "project",
          },
          {
            module: "company_masters",
            moduleAs: "company",
          },
          {
            module: "order_documents",
            moduleAs: "order_documents",
          },
        ],
      };
      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.code == 1 && responseData.data.length > 0) {
        const data = responseData.data[0];
        console.log("data", data);

        setFetchedData(data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };
  const handleDataSync = async (id) => {
    setLoadingData(true);

    try {
      let payload = {
        orderId: id,
      };
      const responseData = await getRecords(payload, "/syncBuyItemsForOrder");

      if (responseData.success) {
        toast.success("Data synced successfully!");
        getEditData(id);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("An error occurred while syncing data.");
    } finally {
      setLoadingData(false);
    }
  };
  // Filter items based on the search query
  const filteredItems =
    formData?.inputData?.orderItemDetails?.filter((row) =>
      row?.item?.item_code?.toLowerCase().includes(searchQuery.toLowerCase())
    ) || [];

  // Calculate totals for the columns
  const totalQty =
    filteredItems &&
    filteredItems?.reduce((acc, item) => acc + (parseFloat(item?.qty) || 0), 0);
  const totalInvoiceQty =
    filteredItems &&
    filteredItems?.reduce(
      (acc, item) => acc + (parseFloat(item?.invoice_qty) || 0),
      0
    );

  const totalUnitRate =
    filteredItems &&
    filteredItems?.reduce(
      (acc, item) => acc + (parseFloat(item?.unit_rate) || 0),
      0
    );

  const totalAmountData =
    filteredItems &&
    filteredItems?.reduce(
      (acc, item) =>
        acc +
        (parseFloat(item?.amount) ||
          parseFloat(item?.unit_rate) * parseFloat(item?.qty)),
      0
    );

  useEffect(() => {
    const getStageOptions = async () => {
      try {
        let payload = {
          modelName: "payment_stage_masters",
        };
        const responseData = await getRecords(payload, "/getRecords");
        setStageOption(responseData.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    getStageOptions();
  }, []);

  const toggleRow = (index) => {
    setExpandedRows((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const FloatValue = (value) => {
    return parseFloat(value).toFixed(3);
  };

  const handleImageClick = (imageSrc) => {
    window.open(imageSrc, "_blank");
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div style={formContentContainer}>
                    <AvForm className="needs-validation">
                      <div className="card mt-4">
                        <div className="card-header">
                          <h5>Order Details</h5>
                          <Button
                            style={{ marginLeft: "10px" }}
                            color="secondary"
                            className="waves-effect waves-light me-1 back-button"
                            onClick={() => navigate(navigatePage?.back)}
                          >
                            Back
                          </Button>
                          <Button
                            color="success"
                            className="waves-effect waves-light me-1 back-button ml-2"
                            style={{ borderRadius: "50%" }}
                            onClick={() => DownloadPDFData("OrderDetails.pdf")}
                          >
                            <i class="fas fa-download"></i>
                          </Button>
                          {(formData.inputData.status == "order_created" ||
                            formData.inputData.status ==
                              "invoice_completed") && (
                            <Button
                              color="info"
                              className="waves-effect waves-light back-button"
                              title="Sync"
                              style={{
                                borderRadius: "50%",
                                marginRight: "12px",
                              }}
                              onClick={() => handleDataSync(id)}
                            >
                              <i className="fas fa-sync-alt"></i>
                            </Button>
                          )}
                        </div>

                        <div className="card-body">
                          <Row>
                            {/* First Section (Left Side) */}
                            <Col
                              md="4"
                              className="border-end border-secondary p-3"
                            >
                              <p>
                                <strong>Project: </strong>
                                {formData?.inputData?.project?.project_name ? (
                                  <span
                                    className="text-primary hover-pointer"
                                    onClick={() =>
                                      navigate(
                                        `/project-view/${
                                          formData?.inputData?.project_id ||
                                          formData?.inputData?.project?.id
                                        }`
                                      )
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    {formData?.inputData?.project?.project_name}
                                  </span>
                                ) : (
                                  "-"
                                )}
                              </p>
                              <p>
                                <strong>Project Code: </strong>
                                {formData?.inputData?.project?.project_code ? (
                                  <span>
                                    {formData?.inputData?.project?.project_code}
                                  </span>
                                ) : (
                                  "-"
                                )}
                              </p>
                              <p>
                                <strong>Customer: </strong>
                                <span
                                  className="text-primary cursor-pointer"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => setIsCustomerModelOpen(true)}
                                >
                                  {formData?.inputData?.company
                                    ? formData.inputData.company.company_name ||
                                      ""
                                    : "-"}
                                </span>
                              </p>
                              {isCustomerModelOpen && (
                                <UserDetailsModal
                                  onClose={() => setIsCustomerModelOpen(false)}
                                  id={
                                    formData?.inputData?.customer_id ||
                                    formData?.inputData?.company?.id
                                  }
                                  type="customer"
                                />
                              )}

                              <p>
                                <strong>Order Amount: </strong>
                                {formData?.inputData?.order_amount || "-"}
                              </p>
                              <p>
                                <strong>Order Status: </strong>
                                {formData?.inputData?.status
                                  ?.split("_")
                                  .join(" ")
                                  .toUpperCase()}
                              </p>
                            </Col>

                            {/* Second Section (Middle Section) */}
                            <Col
                              md="4"
                              className="border-end border-secondary p-3"
                            >
                              <p>
                                <strong>SO No: </strong>
                                {formData?.inputData?.order_no || "-"}
                              </p>
                              <p>
                                <strong>Order Reference No: </strong>
                                {formData?.inputData?.order_ref_no || "-"}
                              </p>
                              <p>
                                <strong>Order Date: </strong>
                                {formatDate(formData?.inputData?.order_date) ||
                                  "-"}
                              </p>
                              <p>
                                <strong>Order created Date: </strong>
                                {new Date(
                                  formData?.inputData?.createdAt
                                ).toLocaleString("en-GB", {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,
                                })}{" "}
                              </p>

                              <p>
                                <strong>GST No: </strong>
                                {formData?.inputData?.company?.gst_no || "-"}
                              </p>
                              <p>
                                <strong>Pan No: </strong>
                                {formData?.inputData?.company?.pan_no || "-"}
                              </p>
                            </Col>

                            {/* Third Section (Right Side) */}
                            <Col md="4" className="p-3">
                              <p>
                                <strong>Address: </strong>
                                {formData?.inputData?.address || "-"}
                              </p>
                              <p>
                                <strong>Shipping Address: </strong>
                                {formData?.inputData?.shipping_address || "-"}
                              </p>
                              <p>
                                <strong>Billing Address: </strong>
                                {formData?.inputData?.billing_address || "-"}
                              </p>
                              <p>
                                <strong>Remark: </strong>
                                {formData?.inputData?.remark || "-"}
                              </p>
                              <p>
                                <strong>Status: </strong>
                                {formData?.inputData?.is_active
                                  ? "ACTIVE"
                                  : "IN-ACTIVE" || "-"}
                              </p>
                            </Col>
                          </Row>
                        </div>
                      </div>
                      <Row className="mt-4">
                        <div className="item-list-container">
                          <div className="d-flex justify-content-between align-items-center">
                            <h6 className="h-6-heading">Item Details</h6>
                            <div className="app-search d-flex d-lg-inline mt-0 p-0">
                              <div className="position-relative">
                                <input
                                  type="text"
                                  className="form-control ps-5"
                                  placeholder="Search by item code..."
                                  value={searchQuery}
                                  onChange={(e) =>
                                    setSearchQuery(e.target.value)
                                  }
                                  style={{
                                    width: "13rem",
                                    padding: "8px 15px",
                                    borderRadius: "8px",
                                    borderColor: "#D2D2D2",
                                    outline: "none",
                                    transition: "all 0.3s ease",
                                    boxShadow: "none",
                                    marginRight: "0.5rem",
                                  }}
                                />
                                <span className="ri-search-line"></span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="table mt-2"
                            style={{
                              // overflow: "auto",
                              overflowX: "auto",
                              overflowY: "auto",
                              maxHeight: "500px",
                              width: "100%",
                              scrollBehavior: "smooth",
                              scrollbarWidth: "thin",
                              msOverflowStyle: "none",
                              zIndex: 0,
                            }}
                          >
                            <table className="table table-hover">
                              <thead
                                style={{
                                  backgroundColor: "#8AC1E8",
                                  position: "sticky",
                                  top: 0,
                                  backgroundColor: "#8AC1E8",
                                  borderBottom: "1px solid black",
                                }}
                              >
                                <tr style={{ borderBottom: "1px solid black" }}>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    Sr. No
                                  </th>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    Item Code
                                  </th>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    Item Desc{" "}
                                  </th>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    Customer Desc
                                  </th>
                                  <th style={{ whiteSpace: "nowrap" }}>UOM</th>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    Order QTY
                                  </th>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    Invoice QTY
                                  </th>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    Unit Rate
                                  </th>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    GST %
                                  </th>
                                  <th
                                    style={{ whiteSpace: "nowrap" }}
                                    colSpan="4"
                                  >
                                    Total Amount
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {filteredItems?.filter((row) => row.is_active)
                                  .length > 0 ? (
                                  filteredItems
                                    ?.filter((row) => row.is_active)
                                    ?.map((row, index) => {
                                      if (
                                        !row.item?.item_code ||
                                        !row.item_id
                                      ) {
                                        return (
                                          <tr>
                                            <td
                                              colSpan="10"
                                              style={{ textAlign: "center" }}
                                            >
                                              No data available.
                                            </td>
                                          </tr>
                                        );
                                      }
                                      return (
                                        <React.Fragment key={id}>
                                          <tr
                                            onClick={() => toggleRow(index)}
                                            style={{
                                              borderBottom: "1px solid #cccccc",
                                              verticalAlign: "middle",
                                              cursor:
                                                row?.item?.type === 1 &&
                                                "pointer",
                                            }}
                                          >
                                            <td>{index + 1}</td>

                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "180px",
                                              }}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                toggleRow(index);
                                              }}
                                            >
                                              <div
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: "5px",
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "nowrap",
                                                  cursor:
                                                    row?.item?.type == 1 &&
                                                    "pointer",
                                                }}
                                                title={
                                                  row?.item?.item_code || "N/A"
                                                }
                                              >
                                                <span>
                                                  {row?.item?.item_code ||
                                                    "N/A"}
                                                </span>

                                                {row?.item?.type === 1 && (
                                                  <Link
                                                    className="text-primary"
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      toggleRow(index);
                                                    }}
                                                    style={{
                                                      cursor: "pointer",
                                                      display: "flex",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <i
                                                      className={`mdi mdi-chevron-${
                                                        expandedRows[index]
                                                          ? "up"
                                                          : "down"
                                                      } font-size-18`}
                                                    ></i>
                                                  </Link>
                                                )}
                                              </div>
                                            </td>

                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "180px",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  display: "-webkit-box",
                                                  WebkitBoxOrient: "vertical",
                                                  WebkitLineClamp: 2,
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "normal",
                                                }}
                                                title={
                                                  row?.item?.description ||
                                                  "N/A"
                                                }
                                              >
                                                {row?.item?.description ||
                                                  "N/A"}
                                              </div>
                                            </td>
                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "180px",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  display: "-webkit-box",
                                                  WebkitBoxOrient: "vertical",
                                                  WebkitLineClamp: 2,
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "normal",
                                                }}
                                                title={
                                                  row?.customer_desc || "N/A"
                                                }
                                              >
                                                {row?.customer_desc || "N/A"}
                                              </div>
                                            </td>
                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "100px",
                                              }}
                                            >
                                              {row?.item?.uom?.uom_name ||
                                                "N/A"}
                                            </td>
                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "100px",
                                              }}
                                            >
                                              {formatNumber(row?.qty) || 0}
                                            </td>
                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "100px",
                                              }}
                                            >
                                              {formatNumber(row?.invoice_qty) ||
                                                0}
                                            </td>
                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "100px",
                                              }}
                                            >
                                              {formatNumber(row?.unit_rate) ||
                                                0}
                                            </td>
                                            <td
                                              colSpan="4"
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "80px",
                                              }}
                                            >
                                              {formatNumber(
                                                row?.gst_percentage || 0
                                              )}
                                            </td>
                                            <td>
                                              {formatNumber(row?.amount) || 0}
                                            </td>
                                          </tr>

                                          <>
                                            {/* Sub Item Header */}
                                            {expandedRows[index] && (
                                              <>
                                                {row?.buy_item_details?.some(
                                                  (child) =>
                                                    child?.item?.item_code ||
                                                    child?.item_code
                                                ) && (
                                                  <>
                                                    <tr
                                                      style={{
                                                        backgroundColor:
                                                          "#d1ecf1",
                                                        fontWeight: "bold",
                                                      }}
                                                    >
                                                      <td></td>
                                                      <td></td>
                                                      <td>Buy Item Code</td>
                                                      <td>
                                                        Buy Item Description
                                                      </td>
                                                      <td>UOM</td>
                                                      <td>BOM QTY</td>
                                                      <td colSpan="10"></td>
                                                    </tr>
                                                    {row &&
                                                      row?.buy_item_details &&
                                                      row?.buy_item_details?.map(
                                                        (child, childIndex) => (
                                                          <tr
                                                            key={`${childIndex}-${childIndex}`}
                                                            style={{
                                                              backgroundColor:
                                                                "",
                                                              borderBottom:
                                                                "1px solid #cccccc",
                                                            }}
                                                          >
                                                            <td></td>
                                                            <td></td>
                                                            <td
                                                              style={{
                                                                paddingLeft:
                                                                  "10px",
                                                                paddingRight:
                                                                  "2px",
                                                              }}
                                                            >
                                                              <div
                                                                style={{
                                                                  display:
                                                                    "-webkit-box",
                                                                  WebkitBoxOrient:
                                                                    "vertical",
                                                                  WebkitLineClamp: 2,
                                                                  overflow:
                                                                    "hidden",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                  whiteSpace:
                                                                    "normal",
                                                                }}
                                                                title={
                                                                  child?.item
                                                                    ?.item_code ||
                                                                  "N/A"
                                                                }
                                                              >
                                                                {child?.item
                                                                  ?.item_code ||
                                                                  "N/A"}
                                                              </div>
                                                            </td>

                                                            <td
                                                              style={{
                                                                paddingLeft:
                                                                  "10px",
                                                                paddingRight:
                                                                  "2px",
                                                              }}
                                                            >
                                                              <div
                                                                style={{
                                                                  display:
                                                                    "-webkit-box",
                                                                  WebkitBoxOrient:
                                                                    "vertical",
                                                                  WebkitLineClamp: 2,
                                                                  overflow:
                                                                    "hidden",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                  whiteSpace:
                                                                    "normal",
                                                                }}
                                                                title={
                                                                  child?.item
                                                                    ?.description ||
                                                                  "N/A"
                                                                }
                                                              >
                                                                {child?.item
                                                                  ?.description ||
                                                                  "N/A"}
                                                              </div>
                                                            </td>

                                                            <td
                                                              style={{
                                                                paddingLeft:
                                                                  "10px",
                                                                paddingRight:
                                                                  "2px",
                                                              }}
                                                            >
                                                              {child?.item?.uom
                                                                ?.uom_name ||
                                                                "N/A"}
                                                            </td>
                                                            <td
                                                              style={{
                                                                paddingLeft:
                                                                  "10px",
                                                                paddingRight:
                                                                  "2px",
                                                              }}
                                                            >
                                                              {formatNumber(
                                                                child?.qty
                                                              ) || 0}
                                                            </td>
                                                            <td colSpan="6"></td>
                                                          </tr>
                                                        )
                                                      )}
                                                  </>
                                                )}
                                              </>
                                            )}
                                          </>
                                        </React.Fragment>
                                      );
                                    })
                                ) : (
                                  <tr>
                                    <td
                                      colSpan="10"
                                      style={{ textAlign: "center" }}
                                    >
                                      No data available.
                                    </td>
                                  </tr>
                                )}

                                {totalQty >= 1 && (
                                  <tr
                                    style={{
                                      borderTop: "2px solid #cccccc",
                                      backgroundColor: "#d9d9d9",
                                      fontWeight: "bold",
                                      position: "sticky",
                                      bottom: 0,
                                      zIndex: 0,
                                    }}
                                  >
                                    <td></td>
                                    <td>Total</td>
                                    <td colSpan="3"></td>
                                    <td>{formatNumber(totalQty)}</td>
                                    <td>{formatNumber(totalInvoiceQty)}</td>
                                    <td>{formatNumber(totalUnitRate)}</td>
                                    <td></td>

                                    <td colSpan="4">
                                      {formatNumber(totalAmountData)}
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Row>

                      <Row className="mt-4">
                        <div className="payment-details-card p-3">
                          <h6 className="h-6-heading">Payment Details</h6>
                          {/* Card Grid Layout for Payment Stages */}
                          <div className="row mt-2">
                            {formData?.inputData?.orderPaymentDetails?.length >
                            0 ? (
                              formData.inputData.orderPaymentDetails.map(
                                (item, index) => {
                                  const matchedStage = stageOption?.find(
                                    (option) => option.id === item.stage_id
                                  );
                                  if (item?.is_active) {
                                    return (
                                      <div
                                        key={index}
                                        className="col-md-6 col-lg-2"
                                      >
                                        <div
                                          className="card"
                                          style={{
                                            marginBottom: "20px",
                                            borderRadius: "5px",
                                            border: "1px solid #ddd",
                                            overflow: "hidden",
                                            transition:
                                              "transform 0.3s ease, box-shadow 0.3s ease",
                                          }}
                                          onMouseOver={(e) => {
                                            e.currentTarget.style.transform =
                                              "scale(1.05)";
                                            e.currentTarget.style.boxShadow =
                                              "0 4px 10px rgba(0, 0, 0, 0.1)";
                                          }}
                                          onMouseOut={(e) => {
                                            e.currentTarget.style.transform =
                                              "scale(1)";
                                            e.currentTarget.style.boxShadow =
                                              "none";
                                          }}
                                        >
                                          <div
                                            className="card-body"
                                            style={{
                                              padding: "16px",
                                              backgroundColor: "#f9f9f9",
                                            }}
                                          >
                                            <h5
                                              className="card-title"
                                              style={{
                                                fontSize: "16px",
                                                fontWeight: "600",
                                                color: "#343a40",
                                                marginBottom: "12px",
                                              }}
                                            >
                                              {matchedStage
                                                ? matchedStage.stage
                                                : "Not specified"}
                                            </h5>
                                            <br />
                                            {item?.percentage
                                              ? `${item.percentage}%`
                                              : "-"}

                                            <p>
                                              {item?.date
                                                ? formatDate(item.date)
                                                : "-"}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  }
                                }
                              )
                            ) : (
                              <div className="col-12 text-center">
                                <div
                                  style={{
                                    padding: "20px",
                                    backgroundColor: "#f8f9fa",
                                    borderRadius: "8px",
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                    color: "#6c757d",
                                  }}
                                >
                                  No data available.
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </Row>

                      <Row
                        className="mt-4"
                        style={{
                          display:
                            formData?.inputData?.order_documents?.length > 0
                              ? "block"
                              : "none",
                        }}
                      >
                        <div className="document-details-card p-3">
                          <h6 className="h-6-heading">Document Details</h6>
                          {/* Card Grid Layout for Document Details */}
                          <div className="row mt-2">
                            {formData?.inputData?.order_documents?.length >
                            0 ? (
                              formData?.inputData?.order_documents?.map(
                                (item, index) => {
                                  return (
                                    item.is_active && (
                                      <div
                                        key={index}
                                        className="col-md-6 col-lg-3"
                                      >
                                        <div
                                          className="card"
                                          style={{
                                            marginBottom: "20px",
                                            borderRadius: "5px",
                                            border: "1px solid #ddd",
                                            overflow: "hidden",
                                            transition:
                                              "transform 0.3s ease, box-shadow 0.3s ease",
                                          }}
                                          onMouseOver={(e) => {
                                            e.currentTarget.style.transform =
                                              "scale(1.05)";
                                            e.currentTarget.style.boxShadow =
                                              "0 4px 10px rgba(0, 0, 0, 0.1)";
                                          }}
                                          onMouseOut={(e) => {
                                            e.currentTarget.style.transform =
                                              "scale(1)";
                                            e.currentTarget.style.boxShadow =
                                              "none";
                                          }}
                                        >
                                          <div
                                            className="card-body"
                                            style={{
                                              padding: "16px",
                                              backgroundColor: "#f9f9f9",
                                            }}
                                          >
                                            <h5
                                              className="card-title"
                                              style={{
                                                fontSize: "16px",
                                                fontWeight: "600",
                                                color: "#343a40",
                                                marginBottom: "12px",
                                              }}
                                            >
                                              {item?.document ||
                                                "Document Name"}
                                            </h5>
                                            <div>
                                              <img
                                                onClick={() =>
                                                  handleImageClick(
                                                    imageURL + item?.file
                                                  )
                                                }
                                                src={imageURL + item?.file}
                                                alt={item?.file}
                                                style={{
                                                  width: "100%",
                                                  height: "200px",
                                                  borderRadius: "5px",
                                                  cursor: "pointer",
                                                }}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  );
                                }
                              )
                            ) : (
                              <div className="col-12 text-center">
                                <div
                                  style={{
                                    padding: "20px",
                                    backgroundColor: "#f8f9fa",
                                    borderRadius: "8px",
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                    color: "#6c757d",
                                  }}
                                >
                                  No data available.
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </Row>
                    </AvForm>
                    {/* Loader Overlay */}
                    {loadingData && (
                      <div style={loaderOverlay}>
                        <LoaderCreatePage />
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
            <div
              style={{
                display: "none",
                position: "absolute",
                left: "-9999px",
              }}
              id="pdfContent"
            >
              <PerchaseOrder data={formData.inputData} data2={stageOption} />
            </div>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default OrderView;
